import { HttpClient } from "@angular/common/http";
import { MITPService } from "../../../../services/mitp.service";
import { Injectable, inject } from "@angular/core";
import { VidalRecosResult } from "../../../../entities/vidal/vidal-recos-result";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class VidalRecosService {
	private httpClient = inject(HttpClient);
	private mitp = inject(MITPService);

	getAll(): Observable<VidalRecosResult[]> {
		return this.httpClient.get<VidalRecosResult[]>(this.mitp.Guidelines() + `/vidal/recos`);
	}

	getById(id: string): Observable<string> {
		return this.httpClient.get<string>(this.mitp.Guidelines() + `/vidal/recos/${id}`);
	}

	search(value: string): Observable<VidalRecosResult[]> {
		return this.httpClient.get<VidalRecosResult[]>(this.mitp.Guidelines() + `/vidal/recos/search/${value}`);
	}
}
